const config = {
    apiBaseUrl: process.env.REACT_APP_ROOT_URL,
  };
  
  export default config;
  